import type { IconSvgObject } from './types';

const Upload01Icon: IconSvgObject = [
  ["path", { d: "M20.9999 17V19.5C20.9999 20.3284 20.3284 21 19.4999 21L4.49994 21C3.67151 21 2.99994 20.3284 2.99994 19.5V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 7.5L12 3L16.5 7.5M12 4L12 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Upload01Icon;
